module.exports = __webpack_public_path__ + "static/img/100-2.a68b665.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/100-2.jpg
// module id = Glhj
// module chunks = 0